import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";


import { configure } from 'vee-validate';


configure({
  classes: {
    invalid: 'field-invalid'
  }
})

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("pt_BR", pt_BR);


import CpfValidate from '@/rules/cpf'
extend('cpf', {
  message: 'CPF inválido!',
  validate: value => { 
    return CpfValidate(value)
  }
});


import DataNascimento from '@/rules/data_nascimento'
extend('data_nascimento', {
  message: 'Data nascimento inválida',
  validate: value => { 
    return DataNascimento(value);
  }
});

import DataFutura from '@/rules/data_futura'
extend('data_futura', {
  message: 'A data deve ser superior a data de HOJE',
  validate: value => { 
    return DataFutura(value);
  }
});


import Data from '@/rules/data'
extend('data', {
  message: 'Data inválida',
  validate: value => { 
    return Data(value);
  }
});

export const validacaoFormulario = {

    components: {
        ValidationProvider,
        ValidationObserver
    }

}

